import axios from 'axios'
import store from '@/store'
import Vuetify from '@/plugins/vuetify'

const lang = Vuetify.locale

const instance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_SERVER_ENDPOINT
})

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    // Embed the auth token to each API request
    if (!config.url.includes('/login') && !config.url.includes('/logout')) {
      config.headers.access_token = store.state.auth.access_token
      config.headers.auth_project_id = store.state.auth.auth_project_id

      // Auto Add device_id to all query — skip if the caller already serialized one.
      // A second append would produce `device_id=A&device_id=B` and let the backend
      // resolve the wrong device when the two values disagree.
      if (config.method === 'get' && !(config.url.includes('/admin_panel/interface/devices') || config.url.includes('/admin_panel/video_call')) && !/[?&]device_id=/.test(config.url)) {
        const device_id = store.state.auth.selected_device
        if (config.url.includes('?') && config.url[config.url.length - 1] !== '?') config.url += `&device_id=${device_id}`
        else config.url += `${config.url.includes('?') ? '' : '?'}device_id=${device_id}`
      }
    }
    return config
  },
  (error) => {
    console.error('error:', error)
    Promise.reject(error)
  }
)

// Response interceptor
instance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // 401 = the access_token is no longer valid (expired or revoked). Tell the
    // user their session expired, then RESET_AUTH_STATUS (clears auth state and
    // routes to /login). Guard on the current auth status so concurrent 401s
    // don't stack duplicate snackbars/redirects, and a stray 401 while already
    // logged out stays silent.
    if (error.response?.status === 401 && store.state.auth.status) {
      store.commit('SET_SNACKBAR', {
        status: true,
        color: 'error',
        text: lang.t('$vuetify.__SnackBar.session_expired'),
        icon: 'close',
        timeout: '3000'
      })
      store.commit('RESET_AUTH_STATUS')
    }
    console.error('error:' + error)
    return Promise.reject(error)
  }
)

export default instance
